import { createSlice } from "@reduxjs/toolkit";
import {
  fetchTeacherSlots,
  createTeacherSlot,
  deleteTeacherSlot,
  updateTeacherSlot, // добавили импорт
} from "./operation.js";

const teacherSlotsSlice = createSlice({
  name: "teacherSlots",
  initialState: {
    slots: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchTeacherSlots.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchTeacherSlots.fulfilled, (state, action) => {
        state.loading = false;
        state.slots = action.payload;
      })
      .addCase(fetchTeacherSlots.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(createTeacherSlot.fulfilled, (state, action) => {
        state.slots.push(action.payload);
      })

      .addCase(deleteTeacherSlot.fulfilled, (state, action) => {
        state.slots = state.slots.filter((slot) => slot.id !== action.payload);
      })

      // ✅ обновление слота
      // .addCase(updateTeacherSlot.fulfilled, (state, action) => {
      //   const { id, updatedData } = action.payload;
      //   const index = state.slots.findIndex((slot) => slot.id === id);
      //   if (index !== -1) {
      //     state.slots[index] = { ...state.slots[index], ...updatedData };
      //   }
      // });
      .addCase(updateTeacherSlot.fulfilled, (state, action) => {
        const index = state.slots.findIndex(
          (slot) => slot.id === action.payload.id
        );
        if (index !== -1) {
          state.slots[index] = action.payload;
        }
      });
  },
});

export default teacherSlotsSlice.reducer;
